<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" (ionDidOpen)="lottieLoad()">
      <ion-header>
        <ion-toolbar>
          <!-- <ion-buttons slot="start">
            <ion-button (click)=close()>
              <ion-icon slot="start" name="arrow-back"></ion-icon>
            </ion-button>  
          </ion-buttons>
          <ion-title>avisacar</ion-title>           -->
          <!-- <ion-list  lines="none"> -->
          <ion-item (click)=close()>
            <!-- <lottie-player autoplay count="1" style="max-height: 24px; max-width: 24px;"  src="../../../../assets/images/lottie/menu-v2.json"></lottie-player> -->
            <ion-icon slot="start" name="arrow-back"></ion-icon>
            <ion-label color="dark" style="font-size:18px;">avisacar</ion-label>
          </ion-item>
          <!-- </ion-list> -->
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <ion-list lines="none">
          <!-- <ion-item-divider mode="md" (click)=close() >
            <ion-icon slot="start" name="arrow-back"></ion-icon>

            <ion-label color="dark" style="font-size:18px;">avisacar</ion-label>             
          </ion-item-divider> -->
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
            <ion-item [routerLink]="[p.url]">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title | translate}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <ion-row class="ion-justify-content-center">
          <div class="line-menu"></div>
        </ion-row>

        <ion-list lines="none">
          
          <!-- href="{{'URL.GET' | translate}}" y quitas el router link, mejor a una funcion revisar-->
          <ion-item routerLink="/" (click)="openUrl('GET')" button>
            <ion-icon slot="start" name="document"></ion-icon>
            <ion-label translate>GET</ion-label>
          </ion-item>
          <ion-item routerLink="/" button disabled>
            <ion-icon slot="start" name="person-add"></ion-icon>
            <ion-label translate>INVITE</ion-label>
          </ion-item>
          <ion-item routerLink="/" button disabled>
            <!-- <ion-icon slot="start" name="thumbs-up"></ion-icon> -->
            <lottie-player #lottieThumb slot="start" (complete)="$event.stop()" style="max-height: 24px; max-width: 24px;"  src="../../../../assets/images/lottie/thumb-up.json"></lottie-player>
            <ion-label translate>EVALUE</ion-label>
          </ion-item>

          <ion-row class="ion-justify-content-center">
            <div class="line-menu"></div>
          </ion-row>

          <ion-item routerLink="/" (click)="lottieLoad(lottieMail);openUrl('MAIL_CONTACT')" button>
            <!-- <ion-icon slot="start" name="mail"></ion-icon> -->
            <lottie-player #lottieMail (complete)="lottieMail.stop()" slot="start" style="max-height: 24px; max-width: 24px;"  src="../../../../assets/images/lottie/mail.json"></lottie-player>
            <ion-label translate>CONTACT</ion-label>
          </ion-item>
          <ion-menu-toggle auto-hide="false">
            <ion-item (click)="showTermsModal()" button>
              <ion-icon slot="start" name="create"></ion-icon>
              <ion-label translate>AUTH.PRIVACY_TERMS</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false">
            <ion-item (click)="showPrivacyModal()" button>
              <!-- <ion-icon slot="start" name="lock"></ion-icon> -->
              <ion-icon slot="start" name="lock-closed"></ion-icon>
              <ion-label translate>AUTH.PRIVACY_POLICY</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle auto-hide="false">
            <ion-item (click)="doLogout()" button>
              <ion-icon slot="start" name="log-out"></ion-icon>
              <ion-label translate>LOGOUT</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>